import 'animate.css';
import './index.less';

import { EventName, EventSource } from '@/shared/constants/event';
import { goToContactSales, setAnonymousUser } from '@/shared/utils/utils';

import { ANONYMOUS_USER_ID } from '@/shared/constants';
import { ArrowRightOutlined } from '@pietra/icons';
import CpuArchitecture from './background';
import React from 'react';
import { sendEventAnalyses } from '@/lib/service';
import storage from '@/shared/utils/storage';
import { useConfigProvider } from '@/lib/context';
import { useRouter } from 'next/navigation';

const HomePageIntro = () => {
  const { isMobile } = useConfigProvider();

  const router = useRouter();

  const handleJoinPietra = () => {
    sendEventAnalyses({
      eventName: EventName.COMMON_VIEW,
      commonType: EventSource.HOMEPAGE,
      commonContent: 'join_pietra',
      sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
      anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
    });

    router.push('/sell-on-pietra/register');
  };

  const heroTitle = (
    <div className="home-page-intro-header-wrap">
      <h1 className="title">
        The <span className="gradient-text">private AI brain</span> for fast growing brands
      </h1>
      <div className="subtitle">
        Unify your data, workflows, and execution across marketing, sourcing, and operations. Access all the models in
        one place with flexible controls to build a system as unique as your brand.
      </div>
    </div>
  );

  const cta = (
    <div className="home-page-intro-cta-container">
      <div className="create-account-button" onClick={handleJoinPietra}>
        <span className="text-content">
          Get started <span className="desktop-only">for free</span>
        </span>
        <ArrowRightOutlined style={{ color: '#fff' }} />
      </div>
      <div className="book-demo-button" onClick={goToContactSales}>
        Book a demo
      </div>
    </div>
  );

  return (
    <div className="home-page-intro-wrap">
      <CpuArchitecture />
      <div className="content">
        {heroTitle}
        {cta}
      </div>
    </div>
  );
};

export default HomePageIntro;
